<template>
  <hel-module title="企业战情室" :class="scope.clsPrefix" v-loading="loading">
    <template slot="extra">
      <div class="tabs">
        <button
          :class="['tab-btn', { active: activeTab === 'business' }]"
          @click.stop="switchTab('business')"
        >
          经营
        </button>
        <button
          :class="['tab-btn', { active: activeTab === 'news' }]"
          @click.stop="switchTab('news')"
        >
          资讯
        </button>
      </div>
      <span class="card-tag chat-tag" @click.stop="toggleChatInput">
        <i class="el-icon-plus"></i>
      </span>
      <span class="card-tag" @click.stop="handleOpenList">全部</span>
    </template>
    <template v-if="currentReportItem">
      <div class="card-content" @click="handleOpenDetail">
        <div class="content-section">
          <div class="section-header">
            <span class="war-section-title">{{ reportTitle }}</span>
          </div>
          <div class="section-desc">{{ reportDesc }}</div>
        </div>
        <div class="action-buttons">
          <button
            v-for="(btn, idx) in tagButtons"
            :key="idx"
            class="btn-secondary"
          >
            {{ btn }}
          </button>
        </div>
        <div class="footer-btn">
          <span class="card-tag detail-tag" @click.stop="handleOpenDetail"
            >详情</span
          >
          <div class="btn-primary" @click.stop="handleSmartAnalysis">
            智能分析
          </div>
        </div>
      </div>
    </template>
    <div v-else class="card-empty">暂无数据</div>

    <!-- 下拉 CosmoClawInput -->
    <transition name="chat-fade">
      <div v-if="chatVisible" class="chat-dropdown">
        <div class="chat-dropdown-inner">
          <div class="chat-dropdown-header">
            <span>向智能体提问</span>
            <i class="el-icon-close" @click="chatVisible = false"></i>
          </div>
          <CosmoClawInput ref="input" force-enable :before-send="handleDropdownSend" />
        </div>
      </div>
    </transition>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import CosmoClawInput from '../../smart-workbench/components/CosmoClawInput.vue'
import { getJobReportPageApi } from '@/api/agentAuth'
import { parseAgentTags } from '@/store/modules/cosmoClaw'

export default {
  name: 'EnterpriseWarRoom',
  components: {
    HelModule,
    CosmoClawInput
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-enterprise-war-room'
      },
      activeTab: 'business',
      currentReportItem: null,
      reportTitle: '企业战情室',
      reportDesc: '',
      tagButtons: [],
      chatVisible: false
    }
  },
  created() {},
  mounted() {
    this.fetchReport(this.activeTab)
  },
  watch: {
    // 发送后自动关闭下拉
    chatVisible(val) {
      if (val) {
        this._savedSessionKey = this.$store.state.cosmoClaw.currentSessionKey
        this._msgCleared = false
        this.$store.commit('cosmoClaw/SET_CURRENT_SESSION_KEY', null)
      } else if (this._savedSessionKey) {
        this.$store.commit('cosmoClaw/SET_CURRENT_SESSION_KEY', this._savedSessionKey)
        this._savedSessionKey = null
      }
    },
    // createNewSession 先清空消息(N→0)，sendMessage 再加一条(0→1)
    '$store.state.cosmoClaw.messages'(msgs) {
      if (!this.chatVisible) return
      if (msgs.length === 0) {
        this._msgCleared = true
      } else if (this._msgCleared && msgs[msgs.length - 1]?.type === 'user') {
        this._msgCleared = false
        this._savedSessionKey = null
        this.chatVisible = false
      }
    }
  },
  methods: {
    async switchTab(tab) {
      this.activeTab = tab
      await this.fetchReport(tab)
    },
    async fetchReport(tab) {
      this.loading = true
      try {
        const category = tab === 'business' ? 'internal' : 'external'
        const params = {
          agentId: this.agentId,
          category: category,
          page: 1,
          size: 1
        }
        const res = await getJobReportPageApi(params)
        if (res && res.data) {
          const item = res.data?.records[0]
          this.currentReportItem = item || null
          this.reportTitle = item.title || '企业战情室'
          this.reportDesc = item.content || item.summary || item.title || ''
          this.tagButtons = item.tags
            ? item.tags.split(',').slice(0, 2)
            : ['查看详情']
        } else {
          this.currentReportItem = null
          this.reportTitle = '企业战情室'
          this.reportDesc = ''
          this.tagButtons = []
        }
      } catch (error) {
        console.error('获取战情室报告失败:', error)
        this.currentReportItem = null
        this.reportTitle = '企业战情室'
        this.reportDesc = ''
        this.tagButtons = []
      } finally {
        this.loading = false
      }
    },
    handleOpenDetail() {
      this.$emit('open-detail', this.currentReportItem)
    },
    handleOpenList() {
      this.$emit('open-list')
    },
    handleSmartAnalysis() {
      this.$emit('smart-analysis', {
        type: 'enterpriseWarRoom',
        content: this.reportDesc || '请深度分析今日内部经营简报'
      })
    },
    toggleChatInput() {
      this.chatVisible = !this.chatVisible
      if (this.chatVisible) {
        // 用当前 agentId 反查真实 agentName，避免 session key 出现 "main"；
        // 优先按真实 id 匹配 store 中已加载的 agentList（支持多实例共存）
        const store = this.$store.state.cosmoClaw
        const rawId = store.currentAgentId
        const queryId = this.$route && this.$route.query && this.$route.query.agentId
        const agentId = rawId || queryId
        if (agentId) {
          const internalName = this._agentNameFromId(agentId)
          if (internalName) {
            this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_NAME', {
              agentName: internalName,
              agentId: String(agentId)
            })
            return
          }
        }
        // 兜底：store 已有当前数字人时直接保留，不强行改写
        if (store.currentAgentName) return
        // 最后兜底：agentList 中第一个启用的数字人
        const first = (this.$store.state.user.agentList || []).find((a) => {
          const { type } = parseAgentTags(a.tags, a.name)
          return (
            type === 'digital-human' &&
            a.enabled !== false &&
            a.deleted === 0
          )
        })
        if (first) {
          const { internalName } = parseAgentTags(first.tags, first.name)
          if (internalName) {
            this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_NAME', {
              agentName: internalName,
              agentId: String(first.agentId || first.id)
            })
          }
        }
      }
    },
    // chat-dropdown 发送：不再本地直接发送，跳转到当前数字人/智能体的对话页进行发送
    handleDropdownSend(payload) {
      const content = ((payload && payload.content) || '').trim()
      if (!content) return false
      this.chatVisible = false
      const agentId =
        (this.$route.query && this.$route.query.agentId) ||
        this.$store.state.cosmoClaw.currentAgentId ||
        this.agentId ||
        ''
      const query = { agentId }
      if (content) query.sendAfter = content
      const nav = this.$router.push({ name: 'SmartEngineChat', query })
      if (nav && typeof nav.catch === 'function') nav.catch(() => {})
      return true
    },
    // 真实 agentId → internalName：优先 agentList，保证多实例各自独立解析
    _agentNameFromId(agentId) {
      if (!agentId) return ''
      const item = (this.$store.state.user.agentList || []).find(
        (a) =>
          String(a.id) === String(agentId) ||
          String(a.agentId || '') === String(agentId)
      )
      if (item) {
        const { internalName } = parseAgentTags(item.tags, item.name)
        if (internalName) return internalName
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: 'rvc-cosmoplat-workspace-enterprise-war-room';
.#{$class-prefix} {
  .card-tag {
    font-size: 12px;
    color: #4a5ff3;
    font-weight: 400;
    cursor: pointer;
    padding: 2px 8px;
  }
  .detail-tag {
    margin-right: 10px;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 8px;
    height: 138px;
    box-sizing: border-box;
    background: #ffffffb3;
    box-shadow: 0 0 8px 0 #005ddd29;
  }
  .card-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 138px;
    font-size: 12px;
    color: #999;
    background: #ffffffb3;
    box-shadow: 0 0 8px 0 #005ddd29;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .content-section {
    flex: 1;
  }
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
  }
  .war-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  .tabs {
    display: flex;
    gap: 4px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    // margin-right: 12px;
  }
  .tab-btn {
    width: 42px;
    height: 20px;
    border: 1px solid #4a5ff3;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 12px;
    font-weight: 400;
    font-size: 12px;
    cursor: pointer;
    background: #fff;
    &.active {
      border: 1px solid #4a5ff3;
      color: #4a5ff3;
    }
    &:not(.active) {
      border: 1px solid #cccccc;
      color: #aaaaaa;
    }
  }
  .esection-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    font-family: PingFangSC-Medium;
  }
  .section-desc {
    font-size: 12px;
    color: #999;
    font-family: PingFangSC-Regular;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .action-buttons {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    // overflow: hidden;
    min-width: 0;
  }
  .btn-secondary {
    padding: 3px 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #666666;
    font-size: 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: PingFangSC-Regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 50%;
  }
  .btn-primary {
    padding: 4px 14px;
    border: none;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: PingFangSC-Regular;
    background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
    border-radius: 12px;
  }
}
.footer-btn {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/* 提问按钮 */
.chat-tag {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #4a5ff3 !important;
}
.chat-tag i {
  font-size: 13px;
}
/* 提问悬浮下拉框 */
.chat-dropdown {
  position: absolute;
  top: 10px;
  z-index: 1000;
  width: 460px;
  margin-top: 4px;
}
.chat-dropdown-inner {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 16px;
  padding: 12px 14px 0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
}
.chat-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.chat-dropdown-header .el-icon-close {
  font-size: 15px;
  color: #999;
  cursor: pointer;
  padding: 2px;
}
.chat-dropdown-header .el-icon-close:hover {
  color: #333;
}
/* 过渡动画 */
.chat-fade-enter-active,
.chat-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.chat-fade-enter,
.chat-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
<style lang="scss">
/* ↓ 以下覆盖 CosmoClawInput 在下拉中的样式（不影响原来的）↓ */
.chat-dropdown-inner {
  .claw-input-wrapper {
    padding: 0 0 10px 0 !important;
  }
  .input-box {
    border: none !important;
    box-shadow: none !important;
    min-height: 90px;
    padding: 0 0 10px 0;
  }
  .input-box:focus-within {
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
